import { PayloadAction, ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit';
import { ITasksState } from '.';
import { api } from '../../api/api';
import { ITicketsBalances } from '../../model/user-info.interface';

export interface ISetHomescreenShortcutResponse {
    isPerformed: boolean;
    reward?: {
        balances: ITicketsBalances;
        exp: number;
    }
};

export const setHomescreenShortcutTask = createAsyncThunk<ISetHomescreenShortcutResponse>(
    'setHomescreenShortcutTask',
    async () => await api.tasks.setHomescreenShortcutTask()
);

const setHomescreenShortcutTaskHandler = (builder: ActionReducerMapBuilder<ITasksState>) => {
    builder
        .addCase(setHomescreenShortcutTask.pending, (state: ITasksState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(setHomescreenShortcutTask.fulfilled, (state: ITasksState, action: PayloadAction<ISetHomescreenShortcutResponse>) => {
            state.loading = false;

            if (!action.payload) {
                state.error = 'Unable to set homescreen shortcut';
                return;
            }

            if (state.homescreenShortcutTask)
                state.homescreenShortcutTask.isPerformed = action.payload.isPerformed;
        })
        .addCase(setHomescreenShortcutTask.rejected, (state: ITasksState) => {
            state.loading = false;
            state.error = 'Unable to set homescreen shortcut';
        });
};

export default setHomescreenShortcutTaskHandler;